export default {
  filters: {
    today: 'Dziś',
    yesterday: 'Wczoraj',
    this_week: 'Ten tydzień',
    last_week: 'Poprzedni tydzień',
    this_month: 'Ten miesiąc',
    last_month: 'Poprzedni miesiąc',
    all: 'Wszystkie',
  },
};
